import { getPropertyItems, propertyValue } from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @param {string} status - Used in translation
 * @returns {TableChart} The chart configuration object.
 */
export default function (context, status) {
  const { id } = context.item
  return {
    key: `status_${status}_property`,
    resource: {
      endpoint: 'total_by_status_room_propertytype',
      filter: {
        'filter.statuses': ['sold', 'reserved', 'sale'],
      },
    },
    type: 'Table',
    sortableBy: ['propertyType', 'housingType', 'count', 'priceTotal', 'averageSquarePrice'],
    sort: {
      propertyType: 1,
    },
    title: {
      id: 'status',
      label: `${context.$t('status')} ${context.$t(`residentialStatus.${status}`).toLowerCase()}`,
      style: true,
    },
    footer: {
      id: `status_${status}_property`,
      label: `${context.$t('showAll')} ${context.$t(`residentialStatus.${status}`).toLowerCase()}`,
      icon: ['fal', 'arrow-to-right'],
      component: 'router-link',
      props: {
        style: { textAlign: 'center', width: '100%' },
        theme: 'primary',
        to: {
          name: 'project-residentials',
          params: { id },
          query: { 'filter.status': status },
        },
      },
    },
    total: ({ data = {} }) => {
      const items = data && data.values ? data.values.find(item => item.status === status) || {} : {}
      return {
        label: true,
        keys: ['count', 'priceTotal'],
        data: items.total,
      }
    },
    actions: [
      {
        id: 'id_1',
        tooltip: 'residentialAccount',
        icon: ['fal', 'arrow-to-right'],
        to: ({ item }) => {
          return {
            name: 'project-residentials',
            params: { id },
            query: {
              'filter.properties': [
                item.propertyType ? `propertyType:${item.propertyType}` : '',
                item.housingType ? `numberOfBedrooms:${item.housingType}` : '',
              ].filter(Boolean),
              'filter.status': status,
            },
          }
        },
      },
    ],
    dimensions: [
      { key: 'propertyType' },
      { key: 'housingType' },
      { key: 'count', type: 'number', align: 'end' },
      { key: 'priceTotal', type: 'currency', align: 'end' },
      { key: 'averageSquarePrice', type: 'currency', align: 'end' },
    ].map(dimension => {
      const { key, align } = dimension

      return {
        id: key,
        label: context.getTranslation(key),
        icon: '',
        style: '',
        align,
        value: ({ item }) => {
          return propertyValue({ dimension: key, item, valueParser: context.valueParser })
        },
      }
    }),
    data: ({ data = {} }) => {
      return getPropertyItems({ data, status })
    },
  }
}
